export const InsuranceStates = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUBMITTED: 'SUBMITTED',
  FAILED: 'FAILED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REQUESTED: 'REQUESTED',
  ACTION_REQUIRED: 'ACTION_REQUIRED',
};
